"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const htmlAttrTypes = {
  dataSet: _propTypes.default.object,
  id: _propTypes.default.string,
  loading: _propTypes.default.oneOf(['eager', 'lazy']),
  // @todo figure out if we need to enum all the possible roles or maybe use
  // an npm package
  role: _propTypes.default.string,
  src: _propTypes.default.string,
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  testID: _propTypes.default.string,
  title: _propTypes.default.string
};
var _default = exports.default = {
  types: htmlAttrTypes,
  select: props => Object.entries(props).reduce((items, _ref) => {
    let [key, value] = _ref;
    return Object.keys(htmlAttrTypes).includes(key) || /^(data|aria)-/.test(key) ? {
      ...items,
      [key]: value
    } : items;
  }, {})
};